import React from 'react';

import i18next from 'i18next';
import { InputGroup as BootstrapInputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../style/components/number.css'

export default function NumberInput({ min, max, type, error, icon, onChange=() => {}, active, append, currentValue, className='', ...props }) {
	// Will control number input
	let [ val, setVal ] = React.useState(null);

	const change = React.useCallback((event) => {
		let { target: { value }} = event;

		if(min >= 0 && value[0] === '-') {
			return event.preventDefault();
		}

		let int = +value;
		if(min && int < min) {
			return event.preventDefault();
		}

		if(max && int > max) {
			return event.preventDefault();
		}

		setVal(int);
		// Parent component thinks this is a real event
		onChange({ target: { value: int }});
	}, [ onChange, min, max ]);

	let extra_props = {};

	if(val !== null) {
		extra_props.value = active ? val.toString() : "";
	}

	return (
        <BootstrapInputGroup className={`${className} wz-neo-input-group ${error ? ' error' : ''}`}>
            {
                icon && <BootstrapInputGroup.Prepend>
                    <BootstrapInputGroup.Text> <FontAwesomeIcon icon={icon || null}/></BootstrapInputGroup.Text>
                </BootstrapInputGroup.Prepend>
            }
            <input
            	type="number"
            	min={min}
            	max={max}
            	onChange={change}
            	className="form-control"
            	{...props}
            	{...extra_props}
            />
            {
                append && <BootstrapInputGroup.Append>
                    <BootstrapInputGroup.Text>{append}</BootstrapInputGroup.Text>
                </BootstrapInputGroup.Append>
            }
        </BootstrapInputGroup>
    );
}

NumberInput.Validator = (value, { max, min }) => {
	if(+value < +min) {
		return {
			result: false,
			message: i18next.t('widget.input.number.range_exceeded_min', { min })
		};
	}

	if(+value > +max) {
		return {
			result: false,
			message: i18next.t('widget.input.number.range_exceeded_max', { max })
		};
	}

	return { result: true };
};
